


















import Vue from 'vue';
import { EventBus } from '@/event-bus';
import {
  configs,
  components,
} from '@/components/global-modal-components/modal-templates';

interface Data {
  visible: boolean;
  template: string;
  params: any;
}

export default Vue.extend({
  name: 'modalWrapper',
  mounted() {
    EventBus.$on('openModal', (template, params) => {
      setTimeout(() => {
        this.openModal(template, params);
      }, 0);
    }).$on('closeModal', () => {
      this.closeModal();
    });
  },
  data(): Data {
    return {
      visible: false,
      template: '',
      params: null,
    };
  },
  computed: {
    config(): any {
      if (configs[this.template]) {
        return configs[this.template];
      } else {
        return {};
      }
    },
  },
  methods: {
    openModal(template, params): void {
      this.template = template;
      this.params = params;
      this.visible = true;
    },
    closeModal(): void {
      this.params = null;
      this.visible = false;
    },
  },
  components,
});
